import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import pure from 'recompose/pure'

const TextField = ({
  source,
  record = {},
  localize,
  translate,
  addLabel,
  sortable,
  locale,
  resource,
  format,
  tag: Tag = 'span',
  ...props
}) => {
  const str = get(record, source)
  return <Tag {...props}>{format ? format(str) : str}</Tag>
}

TextField.propTypes = {
  addLabel: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func,
  source: PropTypes.string.isRequired,
}

const PureTextField = pure(TextField)

PureTextField.defaultProps = {
  addLabel: true,
}

export default PureTextField



// WEBPACK FOOTER //
// ./ui/Data/TextField.js